import IconDiscordBands from '@/assets/icons/font_awesome/discord-brands.svg?react';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ButtonSocialNetwork } from '@/pages/_base/buttons/ButtonSocialNetwork';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_user_auth_provider_discord_unlink } from '@/state/user/auth/providers/remote_user_auth_provider_discord_unlink';
import { is_unlink_disabled } from '@/utils/utils_auth';
import { ENUM__http_route } from '@shared/network/ENUM__http_route';
import { useTranslation } from 'react-i18next';

function ButtonLinkDiscord() {
  const dispatch = use_dispatch();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);
  const { discord_email } = use_slice_user(['discord_email']);

  return (
    <div className="flex gap-2 items-center">
      <ButtonSocialNetwork
        start_slug={ENUM__http_route.DISCORD_AUTH_START}
        linked={Boolean(discord_email)}
        unlink_func={() => dispatch(remote_user_auth_provider_discord_unlink())}
        disabled={is_unlink_disabled(discord_email)}
      >
        <IconDiscordBands className="size-4 !text-bar-foreground" />
        <span className="text-bar-foreground">
          {discord_email
            ? t(i18n_page_settings_user.tabs.account.social_networks_component.button.discord_email.unlink)
            : t(i18n_page_settings_user.tabs.account.social_networks_component.button.discord_email.link)}
        </span>
      </ButtonSocialNetwork>
      <a>{discord_email}</a>
    </div>
  );
}

export default ButtonLinkDiscord;
